<script setup>
import { ref, defineProps, onMounted} from 'vue'

// タブ内のコンポーネント
import TabFieldCost from './TabFieldCost.vue';

const props = defineProps(['field'])
const field = ref(props.field)

// const tabFieldEvent = ref();

onMounted(() => {
  // const tabEl = document.querySelector('#cost-tab')
  // tabEl.addEventListener('shown.bs.tab', () => {
  //   tabFieldEvent.value.reloadCalendar();
  // })
})
</script>

<template>
  <div class="offcanvas-header bg-dark text-light p-2">
    <h5 class="offcanvas-title mx-auto" id="offcanvasCostRightLabel">{{ field?.Name }}</h5>
    <button type="button" class="btn-close text-reset btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>

  <div class="offcanvas-body p-0">
    <ul class="nav nav-fill nav-tabs" id="tabCanvas" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active px-0" id="cost-tab" data-bs-toggle="tab" data-bs-target="#cost-tab-pane" type="button" role="tab" aria-controls="cost-tab-pane" aria-selected="true">
          <i class="bi bi-clipboard-data"></i> 原価管理
        </button>
      </li>
    </ul>

    <div class="tab-content" id="tabContent">
      <div class="tab-pane fade show active" id="cost-tab-pane" role="tabpanel" aria-labelledby="cost-tab" tabindex="0">
        <TabFieldCost :key="field" v-bind:field="field"></TabFieldCost>
      </div>
    </div>
  </div>
</template>

<style scoped>
.nav-tabs{
  background-color: lavender;
}
.tab-content{
  height: 91vh;
  overflow: hidden;
}
</style>
